<!-- =========================================================================================
  File Name: Dashboard.vue
  Description: Dashboard
========================================================================================== -->
<template>
	<div id="dashboard">

    <div class="vx-row">

      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
          <statistics-card-line
            hideChart
            class="mb-base"
            icon="HeartIcon"
            icon-right
            :statistic="totalNursingHome"
            color="danger"
            statisticTitle="Nursing Homes" />
      </div>

      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
          <statistics-card-line
            hideChart
            class="mb-base"
            icon="UsersIcon"
            icon-right
            :statistic="totalStaff"
            statisticTitle="Staff Members"
            color="success" />
      </div>

      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
          <statistics-card-line
            hideChart
            class="mb-base"
            icon="SmileIcon"
            icon-right
            :statistic="totalCustomers"
            statisticTitle="Happy Customers" />
      </div>

      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
          <statistics-card-line
            hideChart
            class="mb-base"
            icon="ShoppingBagIcon"
            icon-right
            :statistic="totalOrders"
            statisticTitle="Orders"
            color="warning" />
      </div>
    </div>
     <vs-row vs-w="12">
      <vs-col class="mb-10" vs-offset="0" vs-type="flex" vs-justify="center" vs-align="center" vs-w="4" vs-lg="12" vs-sm="12" vs-xs="12">
        <vx-card
            title="API Mode"
            title-color="primary"
            card-background="#fff"
            subtitle="Choose the printer's api mode Dev or Live.">
            <vs-switch class="ml-3 mb-3" color="danger" v-model="activeAPIMode">
                  <span slot="on">Live Mode</span>
                  <span slot="off">Dev Mode</span>
                </vs-switch>
          </vx-card>
      </vs-col>
     </vs-row>  

		<div class="vx-row">
      <!-- CARD 9: DISPATCHED ORDERS -->
      <div class="vx-col w-full">
        <vx-card title="Recent Print Orders">
          <div slot="no-body" class="mt-4 ml-5 mr-5">
            <div id="data-list-list-view" class="data-list-container">
              <vs-table ref="table" pagination :max-items="itemsPerPage" search :data="recentOrders">

                <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                  <!-- ITEMS PER PAGE -->
                  <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
                    <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                      <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ recentOrders.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : recentOrders.length }} of {{ queriedItems }}</span>
                      <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                    </div>
                    <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                    <vs-dropdown-menu>

                      <vs-dropdown-item @click="itemsPerPage=4">
                        <span>4</span>
                      </vs-dropdown-item>
                      <vs-dropdown-item @click="itemsPerPage=10">
                        <span>10</span>
                      </vs-dropdown-item>
                      <vs-dropdown-item @click="itemsPerPage=15">
                        <span>15</span>
                      </vs-dropdown-item>
                      <vs-dropdown-item @click="itemsPerPage=20">
                        <span>20</span>
                      </vs-dropdown-item>
                    </vs-dropdown-menu>
                  </vs-dropdown>
                </div>

                <template slot="thead">
                  <vs-th sort-key="nursingHomeName">Nursing Home</vs-th>
                  <vs-th sort-key="custName">Customer Name</vs-th>
                  <vs-th sort-key="email">Email</vs-th>
                  <vs-th >Action</vs-th>

                </template>

                  <template slot-scope="{data}">
                    <tbody>
                      <vs-tr :data="printings" :key="indextr" v-for="(printings, indextr) in data">
                        <vs-td :data="printings.nursingHomeName">
                          <span>{{printings.nursingHomeName}}</span>
                        </vs-td>
                        <vs-td :data="printings.custName">
                          <span>{{printings.custName}}</span>
                        </vs-td>
                        <vs-td :data="printings.email">
                          <span>{{printings.email}}</span>
                        </vs-td>
                        <vs-td :data="printings.path">
                          <vx-tooltip delay=".5s" text="View Photobook">
                            <a class="mr-1.5" :href="printings.path" target="_blank">
                              <feather-icon icon="EyeIcon" svgClasses="w-6 h-6 text-warning"></feather-icon>
                            </a>
                          </vx-tooltip>
                        </vs-td>
                      </vs-tr>
                    </tbody>
                  </template>
              </vs-table>
            </div>
          </div>

        </vx-card>
      </div>
    </div>
	</div>
</template>
<script>
import VueApexCharts from 'vue-apexcharts'
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'

export default{
  data () {
    return {
      subscribersGained: {},
      ordersRecevied: {},
      recentOrders: [],
      totalNursingHome: 0,
      totalCustomers: 0,
      totalStaff: 0,
      totalOrders: 0,
      itemsPerPage: 4,
      isMounted: false,
      activeAPIMode: false
    }
  },
  components: {
    VueApexCharts,
    StatisticsCardLine
  },
  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.recentOrders.length
    }
  },  
  created () {

    this.$vs.loading()
    this.$http.get('/dashboard/')
      .then((response) => {
        this.totalNursingHome = response.data.data[0].totalNursingHome
        this.totalCustomers = response.data.data[0].totalCustomers
        this.totalStaff = response.data.data[0].totalStaff
        this.totalOrders = response.data.data[0].totalOrders
        this.recentOrders = response.data.recent_order
      })
      .catch((error)   => { 
        this.$vs.loading.close()
        console.log(error)
        this.$vs.notify({title:'Something went wrong!', text:'Please try after some time.', color:'warning', position:'top-right', icon:'error', time:5000})
      })

    this.getAPIMode()
    
    // Subscribers gained - Statistics
    this.subscribersGained = {
		    series: [
		      {
		        name: 'Subscribers',
		        data: [28, 40, 36, 52, 38, 60, 55]
		      }
		    ],
		    analyticsData: {
		      subscribers: 92600
		    }
		  },
    this.ordersRecevied = {
		    series: [
		      {
		        name: 'Orders',
		        data: [10, 15, 8, 15, 7, 12, 8]
		      }
		    ],
		    analyticsData: {
		      orders: 1312321
		    }
  		}
  },
  mounted () {
    this.isMounted = true

  },
  methods: {
    getAPIMode () { 
      this.$http.get('/switch-mode/')
        .then((response) => {
          this.$vs.loading.close() 
          if (response.data.data[0].env == 'dev') {
            this.activeAPIMode = false
          } else { this.activeAPIMode = true }
          this.$vs.loading.close()
        })
        .catch((error)   => { 
          this.$vs.loading.close()
          console.log(error)
          this.$vs.notify({title:'Something went wrong!', text:'Unable to find Printer API mode.', color:'warning', position:'top-right', icon:'error', time:5000})
        })
    }
  },
  watch: {
    activeAPIMode (newValue) {
      //called whenever activeAPIMode changes
      this.$vs.loading()
      const formData = new FormData()
      if (newValue == true) {
        var new_mode = 'prod'
      } else {
        var new_mode = 'dev'
      }
      formData.append('env', new_mode)
      this.$http.post('/switch-mode/ ', formData, { headers: {'Content-Type': 'multipart/form-data' }})
        .then((response) => {
          this.$vs.loading.close()
          if (response.data.messageType == 'success') {
            this.$vs.notify({title:'Great!', text:'Api Mode changed', color:'success', position:'top-right', icon:'check_box', time:5000})
          } else {
            this.$vs.notify({title:'Attention!', text:response.data.message, color:'warning', position:'top-right', icon:'error', time:5000})
          }
        })
        .catch((error)   => {
          this.$vs.loading.close()
          console.log(error)
          this.$vs.notify({title:'Something went wrong!', text:'Please try after some time.', color:'warning', position:'top-right', icon:'error', time:5000})
        })

    }
  }
  

}
</script>
<style lang="scss">
#data-list-list-view {
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;
      font-size: 0.8rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }

  }
  
}
</style>